<template>
  <div class="footer_container">
    <img src="../../assets/img/footerpages/wechat.png" alt="达美乐微信也能订单啦。快来扫描二维码关注吧！" width="758" class="bgImg">
    <img src="../../assets/img/footerpages/wechatqrcode.jpg" alt="微信二维码" width="250" class="code">
  </div>
</template>

<script>
  export default {
    name: "vx"
  }
</script>

<style lang="scss" scoped>
  .footer_container {
    width: 100%;
    min-height: 520px;
    display: flex;
    flex-flow: column;
    position: relative;
    background-color: #fff;
    .bgImg {
      position: absolute;
      right: 200px;
      top: 10px;
    }
    .code {
      position: absolute;
      left: 150px;
      top: 160px;
    }
  }
</style>
